import { render, staticRenderFns } from "./operateNormalOff.vue?vue&type=template&id=52aa6a7a&"
import script from "./operateNormalOff.vue?vue&type=script&lang=ts&"
export * from "./operateNormalOff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports